import React from "react";

const TOSPage = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> 1st november, 2024</p>
      <p>Welcome to SMS Textr! By using our services, you agree to these Terms of Service ("Terms"). Please read them carefully.</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using SMS Textr, you acknowledge that you have read, understood, and agree to be bound by these Terms.
        If you do not agree, you must discontinue your use of our services.
      </p>

      <h2>2. Service Description</h2>
      <p>
        SMS Textr provides a pay-as-you-go SMS API service that allows users to send text messages programmatically.
        All messages sent via SMS Textr must comply with local and international laws.
      </p>

      <h2>3. Prohibited Uses</h2>
      <p>You agree not to use SMS Textr for:</p>
      <ul>
        <li>Sending spam or unsolicited messages.</li>
        <li>Violating any laws, including those related to privacy and telecommunications.</li>
        <li>Transmitting harmful, threatening, or defamatory content.</li>
        <li>Sending messages to recipients who have not consented to receive communications from you.</li>
        <li>Sending messages advertising jobs or inviting the recipient to apply for jobs.</li>
        <li>Advertising giveaways, gifts, or contests.</li>
        <li>Payment notifications, which may be deemed spammy.</li>
        <li>Sending messages promoting scams, phishing, fraud, or illegal activities.</li>
        <li>Marijuana, cannabis, or drug-related messages.</li>
        <li>Gambling, casinos, sweepstakes, or raffles.</li>
      </ul>

      <h2>4. User Responsibilities</h2>
      <p>You are responsible for:</p>
      <ul>
        <li>Ensuring that recipients of your messages have explicitly opted in.</li>
        <li>Retaining opt-in records for all recipients.</li>
        <li>Indicating your name or business in your messages.</li>
        <li>Providing opt-out instructions if sending recurring messages. Example: "Reply STOP to opt out."</li>
        <li>Maintaining the security of your account and API key.</li>
        <li>The content and delivery of all messages sent using SMS Textr.</li>
      </ul>

      <h2>5. Sending URLs</h2>
      <p>
        Messages containing URLs require account activation. Shortened URLs (e.g., bit.ly, tinyurl) are prohibited due to network restrictions.
        We may not whitelist your domain if it matches patterns of phishing or abuse.
      </p>

      <h2>6. Message Deliverability</h2>
      <p>
        While SMS Textr strives to provide reliable services, we cannot guarantee the successful delivery of all messages
        due to factors outside our control, such as carrier restrictions or recipient device issues.
      </p>

      <h2>7. Account Suspension or Termination</h2>
      <p>
        We reserve the right to suspend or terminate accounts for violations of these Terms or any misuse of the platform.
        Violations may also void any refund guarantees and result in quota removal.
      </p>

      <h2>8. Data Privacy</h2>
      <p>
        SMS Textr respects your privacy. Our <a href="/privacy-policy">Privacy Policy</a> explains how we handle your data.
        By using our service, you agree to the collection and use of your data as described in the policy.
      </p>

      <h2>9. Liability Limitations</h2>
      <p>SMS Textr is not liable for:</p>
      <ul>
        <li>Damages resulting from service interruptions.</li>
        <li>Losses arising from unauthorized use of your account.</li>
        <li>Issues related to undelivered or misdirected messages.</li>
      </ul>

      <h2>10. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless SMS Textr, its owners, employees, and affiliates from any claims, damages,
        or expenses arising from your use of the service.
      </p>

      <h2>11. Your IP Address</h2>
      <p>
        IPs that exhibit patterns of abusive behavior may be blocked. This includes IPs associated with anonymizing services like Tor.
      </p>

      <h2>12. Support</h2>
      <p>
        For quick answers, view our FAQ or email us at <a href="mailto:smstextr@gmail.com">smstextr@gmail.com</a>.
      </p>

      <h2>13. Modification of Terms</h2>
      <p>
        We may update these Terms periodically. Your continued use of SMS Textr after changes are made signifies your acceptance
        of the updated Terms.
      </p>

      <h2>14. Contact Us</h2>
      <p>If you have questions about these Terms, please contact us at <a href="mailto:smstextr@gmail.com">smstextr@gmail.com</a>.</p>
    </div>
  );
};

export default TOSPage;
